import { queryOptions } from '@tanstack/react-query';

import { API_SERVICE } from '@/constants/api.constant';
import { GET } from '@/lib/fetch';
import type { DataTableQuery } from '@/types/request';
import type {
	DataTableResponse,
	ErrorApiResponse,
	SuccessResponse
} from '@/types/response';

type Options = {
	id: number,
	name: string
};

type BusinessFields = Options & {
	subBusinessFields: Options[]
};

export const masterQueries = {
	keys: () => 'master',
	listCompany: (query: DataTableQuery) =>
		queryOptions<DataTableResponse<Options>, ErrorApiResponse>({
			queryKey: [masterQueries.keys(), 'list', 'companyAffiliate', query],
			queryFn: () =>
				GET({ path: '/company-affiliate', service: API_SERVICE.API_CMS, query })
		}),
	listBusinessArea: (query: DataTableQuery) =>
		queryOptions<DataTableResponse<Options>, ErrorApiResponse>({
			queryKey: [masterQueries.keys(), 'list', 'businessArea', query],
			queryFn: () =>
				GET({ path: '/business-area', service: API_SERVICE.API_CMS, query })
		}),
	listQualification: (query: DataTableQuery) =>
		queryOptions<DataTableResponse<Options>, ErrorApiResponse>({
			queryKey: [masterQueries.keys(), 'list', 'qualification', query],
			queryFn: () =>
				GET({ path: '/qualification', service: API_SERVICE.API_CMS, query })
		}),
	listTypeCoorporation: (query: DataTableQuery) =>
		queryOptions<DataTableResponse<Options>, ErrorApiResponse>({
			queryKey: [masterQueries.keys(), 'list', 'typeCoorporation', query],
			queryFn: () =>
				GET({ path: '/type-cooperation', service: API_SERVICE.API_CMS, query })
		}),
	listProvince: (query: DataTableQuery) =>
		queryOptions<DataTableResponse<Options>, ErrorApiResponse>({
			queryKey: [masterQueries.keys(), 'list', 'province', query],
			queryFn: () =>
				GET({ path: '/province', service: API_SERVICE.API_CMS, query })
		}),
	listCity: (query: DataTableQuery & { provinceId: string | null }) =>
		queryOptions<DataTableResponse<Options>, ErrorApiResponse>({
			queryKey: [masterQueries.keys(), 'list', 'city', query.provinceId, query],
			queryFn: () => GET({ path: '/city', service: API_SERVICE.API_CMS, query }),
			enabled: query.provinceId !== null
		}),
	listDistrict: (query: DataTableQuery & { cityId: string | null }) =>
		queryOptions<DataTableResponse<Options>, ErrorApiResponse>({
			queryKey: [masterQueries.keys(), 'list', 'district', query.cityId, query],
			queryFn: () =>
				GET({ path: '/district', service: API_SERVICE.API_CMS, query }),
			enabled: query.cityId !== null
		}),
	listVillage: (query: DataTableQuery & { districtId: string | null }) =>
		queryOptions<DataTableResponse<Options>, ErrorApiResponse>({
			queryKey: [masterQueries.keys(), 'list', 'village', query.districtId, query],
			queryFn: () =>
				GET({ path: '/village', service: API_SERVICE.API_CMS, query }),
			enabled: query.districtId !== null
		}),
	listBank: (query: DataTableQuery) =>
		queryOptions<DataTableResponse<Options & { code: string }>, ErrorApiResponse>(
			{
				queryKey: [masterQueries.keys(), 'list', 'bank', query],
				queryFn: () => GET({ path: '/bank', service: API_SERVICE.API_CMS, query })
			}
		),
	listBusinessField: (query: DataTableQuery) =>
		queryOptions<DataTableResponse<BusinessFields>, ErrorApiResponse>({
			queryKey: [masterQueries.keys(), 'list', 'businessField', query],
			queryFn: () =>
				GET({ path: '/business-fields', service: API_SERVICE.API_CMS, query })
		}),
	listOccupation: (query: DataTableQuery) =>
		queryOptions<DataTableResponse<Options>, ErrorApiResponse>({
			queryKey: [masterQueries.keys(), 'list', 'occupation', query],
			queryFn: () =>
				GET({ path: '/occupation', service: API_SERVICE.API_CMS, query })
		}),
	mailTemplateById: (id: string) =>
		queryOptions<SuccessResponse<{ body: string }>, ErrorApiResponse>({
			queryKey: [masterQueries.keys(), 'email', id],
			queryFn: () => GET({ path: `/mailer/${id}`, service: API_SERVICE.API })
		})
};
